module.exports = __webpack_public_path__ + "img/illo_4.ac6ab618.svg";